<template>
    <div v-show="show" class="backendFilter-container">
        <div class="mask"></div>
        <div class="backendFilter-content">
            <div class="select">
                <el-select v-model="value" placeholder="请选择模块">
                    <el-option
                        v-for="item in json && json.module"
                        :key="item.key"
                        :label="item.title"
                        :value="item.key">
                    </el-option>
                </el-select>
                <el-select v-if="json1.length > 0" v-model="value1" placeholder="请选择平台">
                    <el-option
                        v-for="item in json1"
                        :key="item.key"
                        :label="item.title"
                        :value="item.key">
                    </el-option>
                </el-select>
                <el-select v-if="json2.length > 0" v-model="value2" placeholder="请选择引擎">
                    <el-option
                        v-for="item in json2"
                        :key="item.key"
                        :label="item.title"
                        :value="item.key">
                    </el-option>
                </el-select>
                <el-select v-if="json3.length > 0" v-model="value3" placeholder="请选择">
                    <el-option
                        v-for="item in json3"
                        :key="item.key"
                        :label="item.title"
                        :value="item.key">
                    </el-option>
                </el-select>
            </div>
            <div class="btn">
                <el-button @click="submit" :disabled="value && value1 && value2 && value3" size="medium" class="green">确定</el-button>
                <el-button @click="close" size="medium">取消</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import common from '@common/common'
    import { apis } from '@common/config'

    export default {
        data() {
            return {
                show: false,
                value: '',
                value1: '',
                value2: '',
                value3: '',
                json: {},
                json1: [],
                json2: [],
                json3: []
            }
        },
        watch: {
            value(to) {
                this.json1 = []
                this.json2 = []
                this.json3 = []
                this.value1 = ''
                this.value2 = ''
                this.value3 = ''
                this.json.module.forEach(el => {
                    if(el.key == to){
                        this.json1 = el.platform
                    }
                }) 
            },
            value1(to) {
                this.json2 = []
                this.json3 = []
                this.value2 = ''
                this.value3 = ''
                this.json1.forEach(el => {
                    if(el.key == to){
                        this.json2 = el.engine
                    }
                }) 
            },
            value2(to) {
                this.json3 = []
                this.value3 = ''
                this.json2.forEach(el => {
                    if(el.key == to){
                        this.json3 = el.template
                    }
                }) 
            }
        },
        methods: {
            close() {
                this.show = false;
                // let dom = document.querySelectorAll('.backendFilter-container')[0]
                // dom.remove()
                window.close()
            },
            open() {
                this.show = true
            },
            submit() {
                let info = {
                    module: this.value,
                    platform: this.value1,
                    engine: this.value2,
                    template: this.value3
                }

                common
                .myFetch(apis.admintranscodesubmit, {data: info, hideLoading: true})
                .then(r => {
                    if (r) {
                        this.close()
                    }
                });
            },
            getList() {
                common
                .myFetch(apis.admintranscodeengine)
                .then(r => {
                    if (r) {
                        // console.log(r)
                        this.json = r.result
                    }
                });
            }
        },
        mounted() {
            // this.json = fJson
            // console.log(fJson)
            this.getList()
        }
    }
</script>

<style lang="less">
.backendFilter-container {
    display: flex;
    flex-direction: column;

    .mask {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: 0 auto;
        background-color: rgba(0, 0, 0, 0.3);
    }

    .backendFilter-content {
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 1080px;
        padding: 40px;
        box-sizing: border-box;
        background: #FFFFFF;
        box-shadow: 4px 4px 10px 0px rgba(5,10,15,0.05);
        border-radius: 4px;

        .select {
            display: flex;
            width: 100%;

            .el-select {
                width: 25%;
                margin: 0 10px;
            }
        }

        .btn {
            display: flex;
            justify-content: center;
            margin-top: 50px;

            .green {
                background-color: #41B48C;
                color: #FFF;
                border: #41B48C;
                box-sizing: border-box;
            }
        }
    }
}
</style>